import * as React from 'react';
import { PreviewMode } from './preview-context';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { composer } from '../../../component-decorators/composer';
import { TextButton } from '@wix/design-system';

interface IDevelopedByPreviewWrapperProps
  extends Partial<WithTranslationProps> {
  name: string;
  children: React.ReactNode;
}
export const DevelopedByWrapper = composer()
  .withTranslation()
  .compose((props: IDevelopedByPreviewWrapperProps) => {
    return (
      <PreviewMode.Consumer>
        {(value) =>
          value.isPreview && !props.name ? (
            <TextButton
              as="a"
              href={`https://dev.wix.com/dc3/my-apps/${value.appId}/market/info/basic-info`}
              target="_blank"
            >
              {props.t('solution.page.preview.developedByPlaceHolder')}
            </TextButton>
          ) : (
            props.children
          )
        }
      </PreviewMode.Consumer>
    );
  });
